<template>
  <div>
    <StackBar id="rijunkeliu" :chartData="chartData" :fontSize="10" />
  </div>
</template>

<script>
import StackBar from "@/components/Echarts/StackBar.vue";

export default {
  name: "GouwuShangquanFenxi",
  props: {
    chartData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  components: {
    StackBar
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less"></style>
